export const getLayoutKey = (hostname, user, userCompany, conservSostL1, tag) => {
  const isTrustConserveDomain = hostname === "nightly.trustconserve.armilis.com" || hostname === "trustconserve.armilis.com";
  const isTwinsDomain = hostname === "nightly.twins.armilis.com" || hostname === "twins.armilis.com";

  const publicTags = ["jZP9Zja79j", "buIl6Jhi1o", "VmRCI2xFOM"];

  if (isTrustConserveDomain) return user ? "trustConserve" : "trustConserveDefault";

  if (isTwinsDomain) {
    if (user) {
      if (conservSostL1) return "trustConserve";
      if (userCompany === "Armilis") return "armilis";
      if (userCompany === "AMG") return "amg";
      if (userCompany === "Alsa") return "alsa";
      if (userCompany === "wilktronics_x_armilis") return "wilktronics";
      return "armilis";
    } else {
      if (tag && publicTags.includes(tag)) return "jzp9zja79j";
      return "default";
    }
  }

  if (user) {
    if (conservSostL1) return "trustConserve";
    if (userCompany === "Armilis") return "armilis";
    if (userCompany === "AMG") return "amg";
    if (userCompany === "Alsa") return "alsa";
    if (userCompany === "wilktronics_x_armilis") return "wilktronics";
    return "armilis";
  } else {
    if (tag && publicTags.includes(tag)) return "jzp9zja79j";
    return "default";
  }
};
